import Module from './Module';

const module = new Module('placeCards', '/api/v1/cards/place');

export const {
  getById: getCardsById,
} = module;

export default module.reducer;



// WEBPACK FOOTER //
// ./src/modules/placeCards.js